import { createApi } from '../createApi';
import * as dummy from '../dummy/banners';
import * as real from '../api/banners';

const api = createApi(dummy, real);

/** 배너 서비스 — 메인 페이지 노출 배너 (할인 / 프로모션 / 이벤트) */
export const bannerService = {
  /* 관리자 */
  adminGetList: api.adminGetBanners,
  adminCreate: api.adminCreateBanner,
  adminUpdate: api.adminUpdateBanner,
  adminDelete: api.adminDeleteBanner,
  adminAutoTranslate: api.adminAutoTranslateBanner,

  /* 공개 */
  getMainBanners: api.getMainBanners,
  getServiceBanner: api.getServiceBanner, // 서비스별 고정 배너(현재 언어 우선) 단일 조회
};
